import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const ContactMasterDetailViewDialogTourConfig: AgTechTourConfig = {
    id: 'contact-master-detail-dialog-tour',
    name: 'My Contacts Tour',
    steps: [
        {
            targetId: 'contacts-create-btn',
            title: 'Create Contact',
            description: 'Create a new contact to track for your operation.',
            position: 'bottom',
        },
        {
            targetId: 'contacts-import-btn',
            title: 'Import Contacts',
            description: 'Import multiple contacts at once from a spreadsheet file.',
            position: 'bottom',
        },
        {
            targetId: 'contacts-list-panel',
            title: 'Contacts List',
            description: 'Browse all contacts for your operation here. Click any contact to view their full details on the right.',
            position: 'right',
        },
        {
            targetId: 'contacts-general-tab',
            title: 'General Tab',
            description: 'View and update general contact information such as name, email, phone number, and address.',
            onActivate: () => document.getElementById('contacts-general-tab')?.click(),
        },
        {
            targetId: 'contacts-notes-tab',
            title: 'Notes Tab',
            description: 'Add and review notes for this contact to keep track of important details.',
            onActivate: () => document.getElementById('contacts-notes-tab')?.click(),
        },
        {
            targetId: 'contacts-credits-tab',
            title: 'Credits Tab',
            description: 'View and manage any credits on file for this contact.',
            onActivate: () => document.getElementById('contacts-credits-tab')?.click(),
        },
    ]
}
